import { useEffect as d } from "react";
import { DropdownStates as a } from "../utils/states.js";
const p = _ref => {
  let {
    isOpen: e,
    setDropdownState: t,
    wrapperRef: o,
    showList: n
  } = _ref;
  d(() => {
    const r = i => {
      var s;
      const w = i.target;
      e && !((s = o.current) != null && s.contains(w)) && !n && t(a.CLOSED);
    };
    return window.addEventListener("mousedown", r), () => {
      window.removeEventListener("mousedown", r);
    };
  }, [e, t, n, o]);
};
export { p as useClickOutside };